import { ContentStepForm } from '../../../schemas/contentStepSchema';
import { CreateOrUpdateProgramPayload } from '../../../types/program';

export const getContentStepProgramPayload = (
  fields: ContentStepForm
): Partial<CreateOrUpdateProgramPayload> => {
  const modules = (fields.modules || []).map((module, moduleIdx) => ({
    id: module.moduleId,
    title: module.title,
    order: moduleIdx + 1,
    description: module.description || '',
    subModules: [],
    contents: (module.contents || []).map((content, contentIdx) => ({
      id: content.contentId,
      title: content.title,
      description: content.description || '',
      type: content.type,
      directory: content.directory || '',
      value: content.file.fileUrl,
      order: contentIdx + 1,
      tags: content.tags || [],
      groupId: null,
      instructorIds: !content.instructorId ? [] : [content.instructorId],
      thumbVideo: {
        neutral: content.neutralThumb?.preview || '',
        female: content.femaleThumb?.preview || '',
        male: content.maleThumb?.preview || '',
      },
    })),
  }));
  return {
    modules,
  };
};
